import _ from 'lodash'
export const validateYoutubeURL = url => {
    return !url
        ? { error: false, message: '' }
        : !checkValidYouTubeURL(url)
            ? { error: true, message: 'El enlace no es válido' }
            : { error: false, message: '' }
}

const checkValidYouTubeURL = elem => {
    const regExp = RegExp(
        /^((?:https?:)?\/\/)?((?:www|m)\.)?((?:youtube\.com|youtu.be))(\/(?:[\w]+\?v=|embed\/|v\/)?)([\w]+)(\S+)?$/
    )
    return regExp.test(elem)
}

export const youtube_parser = (urlForParser) => {
    const regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/
    const match = urlForParser.match(regExp)
    return (match && match[7].length === 11) ? match[7] : false
}

export const removeAccents = (str) => {
    return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
}

export const normalizeString = (str) => removeAccents(str.toString().toUpperCase())

Array.prototype.sortByLabel = function() { 
    return this.sort((a, b) => (a.label.toLowerCase() < b.label.toLowerCase()) ? -1 : (a.label.toLowerCase() > b.label.toLowerCase()) ? 1 : 0); 
}

export const downloadPdf = data => {
    const file = new Blob([data], { type: 'text/html' })
    const fileURL = URL.createObjectURL(file)
    window.open(fileURL, '_blank')
}

export const toTitleCase = (str) =>
    str?.replace(/\w\S*/g, (txt) => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()) || ''

export const createFileFormData = (files = {}, body = {}) => {
    const { newFiles = [], reorderedFiles = [], deletedFiles = [], filesToAssociate = [] } = files
    const YOUTUBE_TYPE = 'video/youtube'
    const formData = new FormData()
    const newFilesIds = []
    const filesToAssociateIds = []

    delete body.reorderedFiles
    for (const key in body) {
        if (_.isUndefined(body[key])) {
            body[key] = null
        }
        formData.append(key, JSON.stringify(body[key]))
    }

    formData.append('reorderedFiles', JSON.stringify(reorderedFiles))
    formData.append('deletedFiles', JSON.stringify(deletedFiles))

    filesToAssociate.forEach(fileObj => {
        filesToAssociateIds.push(fileObj)
    })
    newFiles.forEach(async fileObj => {
        if (!fileObj.file) return
        // Se inicializa el objeto
        let formattedFile = fileObj.file
        // Si el tipo del archivo es de youtube
        // Se necesita generar un Blob con los datos del video
        if (fileObj.file.type === YOUTUBE_TYPE) {
            formattedFile = new Blob([JSON.stringify(fileObj.file, null, 2)], {
                type: YOUTUBE_TYPE
            })
        }

        formData.append('file', formattedFile)
        newFilesIds.push(fileObj.id)
    })
    formData.append('newFilesIds', JSON.stringify(newFilesIds))
    formData.append('filesToAssociateIds', JSON.stringify(filesToAssociateIds))
    return formData
}

export const truncNumber = (num) => {
  if (num == null) return null

 return !Number.isNaN(Math.trunc(num)) ? Math.trunc(num) : null
}

export function formatSecondsInHoursMinutes(totalSeconds) {
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  const m = String(minutes).padStart(2, '0');
  const s = String(seconds).padStart(2, '0');

  if (hours > 0) {
    const h = String(hours).padStart(2, '0');
    return `${h}:${m}:${s}`; // Returns hh:mm:ss
  }

  return `${m}:${s}`; // Returns mm:ss
}
